import { render, staticRenderFns } from "./EditUserRole.vue?vue&type=template&id=91ea58d6&"
import script from "./EditUserRole.vue?vue&type=script&lang=js&"
export * from "./EditUserRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports